
// src/pages/Section21.js
import React, { useState, useEffect } from "react";
import { FileText } from "lucide-react";
import { useLanguage } from "../../StoreContext/LanguageContext";

const RailwaySection21 = ({ setSubComponent }) => {
  const { language, translations } = useLanguage();
  const [currentProjectId, setCurrentProjectId] = useState(null);
  const [currentProposalId, setCurrentProposalId] = useState(null);

  // ✅ Fetch projectId
  useEffect(() => {
    const getProjectInfo = () => {
      const currentProjectData = localStorage.getItem("currentProjectData");
      if (currentProjectData) {
        try {
          const projectData = JSON.parse(currentProjectData);
          return {
            id: projectData.project_id || projectData.id,
            name: projectData.project_name || projectData.name,
          };
        } catch (e) {
          console.error("Error parsing currentProjectData:", e);
        }
      }
      const selectedProject = localStorage.getItem("selectedProject");
      if (selectedProject) {
        try {
          const project = JSON.parse(selectedProject);
          return {
            id: project.project_id || project.id,
            name: project.project_name || project.name,
          };
        } catch (e) {
          console.error("Error parsing selectedProject:", e);
        }
      }
      const userData = localStorage.getItem("userData");
      if (userData) {
        try {
          const user = JSON.parse(userData);
          return {
            id: user.data?.project_id || user.project_id,
            name: user.data?.project_name || user.project_name,
          };
        } catch (e) {
          console.error("Error parsing userData:", e);
        }
      }
      return { id: null, name: null };
    };

    const projectInfo = getProjectInfo();
    setCurrentProjectId(projectInfo.id);
  }, []);

  // ✅ Fetch proposalId
  useEffect(() => {
    const getProposalInfo = () => {
      const currentProposal = JSON.parse(
        localStorage.getItem("userData") || "{}"
      );
      if (currentProposal) {
        try {
          return (
            currentProposal?.data?.default_proposal ||
            currentProposal?.data?.proposal_id ||
            currentProposal?.default_proposal ||
            currentProposal?.proposal_id ||
            null
          );
        } catch (e) {
          console.error("Error parsing proposal:", e);
        }
      }
      return null;
    };

    setCurrentProposalId(getProposalInfo());
  }, []);

  // ✅ Button Handlers
  const handleSection21_1 = () => setSubComponent("RailwaySection21_1");
  const handleSection21_1_4 = () => setSubComponent("Section21_1_4");
  const handleUnderSection21 = () => setSubComponent("UnderSection21");

  return (
    <div className="p-6">
      <div className="flex flex-wrap gap-4">
        <button
          onClick={handleSection21_1}
          className="px-5 py-3 text-sm bg-green-600 hover:bg-green-700 text-white rounded-xl flex items-center space-x-2 shadow-md"
        >
          <FileText className="h-5 w-5" />
          <span>{translations[language].Section21_1}</span>
        </button>

        <button
          onClick={handleSection21_1_4}
          className="px-5 py-3 text-sm bg-green-600 hover:bg-green-700 text-white rounded-xl flex items-center space-x-2 shadow-md"
        >
          <FileText className="h-5 w-5" />
          <span>{translations[language].Section21_1_4}</span>
        </button>

        <button
          onClick={handleUnderSection21}
          className="px-5 py-3 text-sm bg-green-600 hover:bg-green-700 text-white rounded-xl flex items-center space-x-2 shadow-md"
        >
          <FileText className="h-5 w-5" />
          <span>{translations[language].UnderSection21}</span>
        </button>
      </div>
    </div>
  );
};

export default RailwaySection21;
